



























import Vue from 'vue'

import WaitListChange from '@/components/waitList/WaitListChange.vue'
import WaitListNotifyMe from '@/components/waitList/WaitListNotifyMe.vue'

import { ApiService } from '@/services'
import { ReservationCategory } from '@/enums/reservationCategory'

export default Vue.extend({
  name: 'WaitListModal',

  components: {
    WaitListChange,
    WaitListNotifyMe,
  },

  props: {
    brand: {
      type: String,
      required: false,
      default: '',
    },
    offerId: {
      type: String,
      required: true,
    },
    addressId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      waitListId: null,
      showNotify: false,
      showChange: false,
      currentWaitListBrand: null,
    }
  },

  mounted: function () {
    ApiService.get('reservation/reserved').then((response) => {
      this.loading = false

      const existingWaitList = response.data.find((reservation) => reservation.category === 'Wait List')

      if (!existingWaitList || (existingWaitList.offer.id === this.offerId && existingWaitList.wait_list.addressId === this.addressId)) {
        this.showNotify = true
        this.waitListId = existingWaitList ? existingWaitList.wait_list.id : null
      } else {
        this.showChange = true
        this.currentWaitListBrand = existingWaitList.business.brand
      }
    })
  },

  methods: {
    createWaitList() {
      ApiService.post(`waitList`, {
        offerId: this.offerId,
        addressId: this.addressId,
      })
        .then((response) => {
          if (response.data.error) {
            throw Error(response.data.error)
          }

          this.$store.dispatch('reservations/fetchReservationSummary')

          this.$toast.success(`Great! You'll be notified when you when you can redeem this offer`)

          this.$router.push({ path: `/user/offers/${ReservationCategory.CLAIMED}` })
        })
        .catch((error) => {
          this.$toast.error(error)
        })
    },
  },
})
